import { Security } from 'common/types/company';
import { FIRST_ROW_WITH_DATA } from '../constants';

const getSumExprCells = (colLegend: string, securities: Security[]) =>
  securities.map((_, index) => `${colLegend}${index + FIRST_ROW_WITH_DATA}`).join(',');

export default getSumExprCells;
